import script from "./DiffFileTreeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiffFileTreeItem.vue?vue&type=script&lang=ts&setup=true"

import "./DiffFileTreeItem.vue?vue&type=style&index=0&id=0f02a01e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f02a01e"]])

export default __exports__